//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import BaseClient from './BaseClient';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IContentApiClient {
    /**
     * Gets all global redirects manually set in Umbraco. If a hostname is specified, all redirects matching
    that site is also included. Redirects to the same site will have relative URLs.
     * @param hostname (optional) Optional hostname to get local redirects for.
     * @param rootKey (optional) Optional key of the root node to get local redirects for.
     * @return A list of redirects.
     */
    redirects(hostname?: string | undefined, rootKey?: string | undefined): Promise<RedirectDto[]>;
    /**
     * @return OK
     */
    version(): Promise<string>;
}

export class ContentApiClient extends BaseClient implements IContentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets all global redirects manually set in Umbraco. If a hostname is specified, all redirects matching
    that site is also included. Redirects to the same site will have relative URLs.
     * @param hostname (optional) Optional hostname to get local redirects for.
     * @param rootKey (optional) Optional key of the root node to get local redirects for.
     * @return A list of redirects.
     */
    redirects(hostname?: string | undefined, rootKey?: string | undefined, signal?: AbortSignal): Promise<RedirectDto[]> {
        let url_ = this.baseUrl + "/api/redirects?";
        if (hostname === null)
            throw new Error("The parameter 'hostname' cannot be null.");
        else if (hostname !== undefined)
            url_ += "hostname=" + encodeURIComponent("" + hostname) + "&";
        if (rootKey === null)
            throw new Error("The parameter 'rootKey' cannot be null.");
        else if (rootKey !== undefined)
            url_ += "rootKey=" + encodeURIComponent("" + rootKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRedirects(_response);
        });
    }

    protected processRedirects(response: AxiosResponse): Promise<RedirectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RedirectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RedirectDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Both hostname and root key are specified.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RedirectDto[]>(null as any);
    }

    /**
     * @return OK
     */
    version(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class RedirectDto implements IRedirectDto {
    oldUrl!: string;
    newUrl!: string;
    isPermanent!: boolean;

    constructor(data?: IRedirectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldUrl = _data["oldUrl"];
            this.newUrl = _data["newUrl"];
            this.isPermanent = _data["isPermanent"];
        }
    }

    static fromJS(data: any): RedirectDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldUrl"] = this.oldUrl;
        data["newUrl"] = this.newUrl;
        data["isPermanent"] = this.isPermanent;
        return data;
    }
}

export interface IRedirectDto {
    oldUrl: string;
    newUrl: string;
    isPermanent: boolean;
}

export class ContentApiClientException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isContentApiClientException = true;

    static isContentApiClientException(obj: any): obj is ContentApiClientException {
        return obj.isContentApiClientException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ContentApiClientException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}